import { Navigate, Outlet } from 'react-router-dom';

import { selectIsAuthenticated } from '~modules/auth/store/auth-selectors';

import { useAppSelector } from '~system/store/configure-store';

import { ROUTES } from '~app/router/routes';

export const LessorGuestOnlyRoute = () => {
  const isAuthenticated = useAppSelector(selectIsAuthenticated);

  return isAuthenticated ? <Navigate to={ROUTES.DASHBOARD} /> : <Outlet />;
};
